const COVERAGE_TURNOVER_LABELS = {
  medium: 'Medium',
  very_high: 'Very High',
  low: 'Low',
  very_low: 'Very Low',
  high: 'High',
}

export default COVERAGE_TURNOVER_LABELS
